import axios from 'axios'
export default function(url,params){
    // var host = 'http://uat-website.mzscgpt.cn'
    // var host = 'http://wwwapi.fonedoor.com'
    // var host = 'http://192.168.10.143:91'
    // var host = 'http://uat-wwwapi.fonedoor.com'
    // var host = 'http://wwwapi.fonedoor.com'
    var host = 'http://47.112.120.160:82'

    return axios.get(host+url, {
        params: params
    })
}



// WEBPACK FOOTER //
// ./src/api/get.js